import { z } from 'zod';
/** The raw phone as typed. The service normalises it to E.164 with the domain package. */
const rawPhone = z.string().trim().min(1).max(20);
export const otpRequestSchema = z.object({ phone: rawPhone });
export const otpVerifySchema = z.object({
    phone: rawPhone,
    code: z.string().regex(/^\d{6}$/, 'Enter the 6 digit code'),
    device: z.string().trim().max(120).optional(),
});
export const switchAgencySchema = z.object({ agencyId: z.string().uuid() });
//# sourceMappingURL=auth.js.map